<template>
    <div>
        <h1>Forbidden</h1>
    </div>   
</template>

<script>
export default {
  name: '403',
}
</script>